import { Modal } from "../Modal";
import React, { useState } from "react";
import styles from "src/components/organisms/PromoCodeModal/styles.module.css";
import { Msg } from "src/i18n/Msg";
import { PromoCodeForm } from "src/components/forms/PromoCodeForm";

type Props = {
  isOpen: boolean;
  close: () => void;
};

type Applied = { minDeposit: number; bonus: number };

export const PromoCodeModal: React.FC<Props> = ({ isOpen, close }) => {
  const [applied, setApplied] = useState<Applied | null>(null);

  const handleClose = () => {
    setApplied(null);
    close();
  };

  return (
    <Modal
      isVisible={isOpen}
      closeModal={handleClose}
      className={styles.promoCodeModal}
      isShowClose
    >
      {applied ? (
        <div className={styles.applied}>
          <h3>
            <Msg id="components.organisms.PromoCodeModal.applied.title" />
          </h3>
          <p className={styles.appliedText}>
            <Msg
              id="components.organisms.PromoCodeModal.applied.text"
              values={{
                minDeposit: String(applied.minDeposit),
                bonus: String(applied.bonus),
              }}
            />
          </p>
          <button
            type="button"
            className={styles.appliedButton}
            onClick={handleClose}
          >
            <Msg id="components.organisms.PromoCodeModal.applied.button" />
          </button>
        </div>
      ) : (
        <>
          <h3>
            <Msg id="components.organisms.PromoCodeModal.title" />
          </h3>
          <PromoCodeForm close={handleClose} onApplied={setApplied} />
        </>
      )}
    </Modal>
  );
};
